import React, {
    useContext
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { TrackingContext } from '@vrbo/react-event-tracking';
import TranslationUtil from '../../../utils/TranslationUtil';
import helpIcon from '../../../assets/images/help-icon-dark.svg';
import BrandLogo from '../../BrandLogo';
import { createInteractionEvent } from '../../../utils/EventProviders/EgClickstreamUtil';
import LypCta from './LypCta';
import { DomUtilsCtx } from '../../../contexts/domUtils';

export function LypHeader(props) {
    const { trigger } = useContext(TrackingContext);
    const {
        helpText,
        helpLink,
        logo,
        getFooterLinks,
        lypCtaText,
        hideCta
    } = props;

    const {
        isTopOfPage
    } = useContext(DomUtilsCtx);

    const triggerClickstream = () => {
        trigger('interaction', createInteractionEvent('contact_us.selected', 'Property Onboarding', '', null, '2.4.0'));
        return true;
    };

    return (
        <nav
            className={classNames(
                'navbar',
                {
                    'header-scroll-not-top': !isTopOfPage
                }
            )}
        >
            <div
                className={classNames(
                    'header',
                    {
                        'header-scroll-not-top': !isTopOfPage
                    }
                )}
            >
                <div className="logo">
                    <BrandLogo callStatus={getFooterLinks} logo={logo} />
                </div>
                <LypCta
                    lypCtaText={lypCtaText}
                    display={!hideCta}
                />

                {!!helpText && !!helpLink && (
                    <div className="help">
                        <a href={helpLink} onClick={triggerClickstream}>
                            <img alt="" src={helpIcon} />
                            {helpText}
                        </a>
                    </div>
                )}
            </div>
        </nav>
    );
}

LypHeader.propTypes = {
    // eslint-disable-next-line react/require-default-props
    logo: PropTypes.shape({
        image: PropTypes.string,
        link: PropTypes.string,
        text: PropTypes.string,
        altText: PropTypes.string
    }),
    helpText: PropTypes.string.isRequired,
    helpLink: PropTypes.string.isRequired,
    // eslint-disable-next-line react/require-default-props
    history: PropTypes.shape({
        replace: PropTypes.func
    }).isRequired,
    getFooterLinks: PropTypes.shape({
        start: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        fail: PropTypes.bool.isRequired
    }).isRequired,
    features: PropTypes.shape({
        isLanguageSelector: PropTypes.bool
    }).isRequired,
    lypCtaText: PropTypes.string.isRequired,
    hideCta: PropTypes.bool.isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app } = state;
    const {
        footerLinks, getFooterLinks, siteUrls, features
    } = app;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const defaultLogo = {
        image: '',
        link: '',
        text: '',
        altText: ''
    };

    const lypCtaText = translations.getTranslation('valueProposition.header');
    return {
        helpText: translations.getTranslation('lyp.header.help.text'),
        helpLink: siteUrls && siteUrls.lypContactUsUrl ? siteUrls.lypContactUsUrl : '',
        logo: footerLinks && footerLinks.logo ? footerLinks.logo : defaultLogo,
        getFooterLinks,
        features,
        lypCtaText
    };
};

const ConnectedLypHeader = connect(mapStateToProps)(LypHeader);
export default ConnectedLypHeader;
